module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10031.0984020b.jpg";